import * as React from 'react';
// TODO: deep import is bad, fix importing from index
import Link from '@wix/thunderbolt-elements/components/Link';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import classNames from 'clsx';
import type {
  ICollapsibleTextControllerProps,
  ExpandControlData,
  ExpandControlProps,
} from '../../../../CollapsibleText.types';
import styles from '../CollapsibleText.module.scss';
import { ExpandModeValues, TestIds } from '../../../../constants';
import semanticClassNames from '../../../../CollapsibleText.semanticClassNames';

const buttonSemanticClassName = formatClassNames(semanticClassNames.button);

export type ExpandControlCompProps = ExpandControlData &
  ExpandControlProps &
  ICollapsibleTextControllerProps;

export const ExpandControl: React.FC<ExpandControlCompProps> = ({
  link,
  linkText,
  expandMode,
  readMoreText,
  readLessText,
  textDescription,
  isExpanded,
  partToPreviewStateMap,
  setIsExpanded,
  reportBiOnExpandClick,
  reportBiOnLinkClick,
}) => {
  const onExpandClick = () => {
    setIsExpanded(!isExpanded);
    reportBiOnExpandClick(!isExpanded);
  };

  const onLinkClick = () => {
    reportBiOnLinkClick();
  };

  switch (expandMode) {
    case ExpandModeValues.Expand:
      return (
        <button
          className={classNames(styles.expandControl, buttonSemanticClassName)}
          onClick={onExpandClick}
          data-testid={TestIds.viewer.expand_control}
          data-preview={partToPreviewStateMap?.button}
          aria-expanded={isExpanded}
          aria-label={textDescription}
        >
          {isExpanded ? readLessText : readMoreText}
        </button>
      );
    case ExpandModeValues.Link:
      return (
        <Link
          {...link}
          onClick={onLinkClick}
          aria-label={textDescription}
          className={classNames(
            styles['expand-control'],
            buttonSemanticClassName,
          )}
          dataTestId={TestIds.viewer.expand_control}
          dataPreview={partToPreviewStateMap?.button}
        >
          {linkText}
        </Link>
      );
    default:
      return null;
  }
};
